module.exports = __webpack_public_path__ + "static/media/logo.884a2adb.png";